import UploadBlock from 'components/molecules/gallery/UploadBlock';
import GalleryContent from 'components/organisms/gallery/GalleryContent';
import { GalleryContext } from 'context/gallery/GalleryContext';
import React, { useContext, useEffect } from 'react';

const GalleryTemplate: React.FC = () => {
    const { state, setGalleryState } = useContext(GalleryContext);

    useEffect(() => {
        setGalleryState({ ...state, isUploading: false });
    }, []);
    return (
        <div>
            {state?.isUploading && <UploadBlock />}
            <GalleryContent />
        </div>
    );
};

export default GalleryTemplate;
